module.exports = __webpack_public_path__ + "media/images/news/icon-right-d424e39ad41122a0c1481cad81be8c79.svg";